<!-- eslint-disable antfu/top-level-function -->

<script setup lang="ts">
import { StructuredButton, StructuredSplit, StructuredTextAndImage, VideoBase } from "#components";
import { Image as DatocmsImage, StructuredText as DatocmsStructuredText } from "vue-datocms";

const props = defineProps({
  data: {} as any,
});

// https://www.datocms.com/docs/nuxt/rendering-structured-text-fields
// https://www.datocms.com/docs/structured-text/dast#block
// https://www.datocms.com/docs/nuxt/managing-images
const renderBlock = ({ record }: { record: any }) => {
  if (record._modelApiKey === "button") {
    return h(
      "div",
      { class: "flex justify-start mb-xl", "data-datocms-content-link-boundary": "", },
      [h(StructuredButton, { data: record })]);
  }

  if (record._modelApiKey === "image_block" || record.__typename === "SingleImageRecord") {
    return h("div", { class: "mb-xl", "data-datocms-content-link-boundary": "" }, [h(DatocmsImage, { data: record.image.responsiveImage })]);
  }

  if (record._modelApiKey === "split_item") {
    // use a kind of *-bleed, only for large desktop screens
    return h("div", { class: "mb-xl xl:w-screen xl:max-w-[1200px] xl:left-1/2 xl:right-1/2 xl:mx-[-600px] xl:relative", "data-datocms-content-link-boundary": "" }, [h(StructuredSplit, { data: record })]);
  }

  if (record._modelApiKey === "text_and_image") {
    return h("div", { class: "mb-xl", "data-datocms-content-link-boundary": "" }, [h(StructuredTextAndImage, { data: record })]);
  }

  if (record._modelApiKey === "video") {
    return h("div", { class: "mb-xl", "data-datocms-content-link-boundary": "" }, [h(VideoBase, { video: record })]);
  }

  return h(
    "div",
    {},
    [
      h("p", {}, "Don't know how to render a block!"),
      h("pre", {}, JSON.stringify(record, null, 2)),
    ],
  );
};
</script>

<template>
  <div class="structured-content" data-datocms-content-link-group>
    <DatocmsStructuredText :data="props.data" :render-block="renderBlock" />
  </div>
</template>

<style scoped>

</style>
